import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import cn from 'classnames';
import { ControlAppearanceType, safeInvoke, isDefined } from '../../../library';
import { Message } from '../../message';
import { ToasterPosition } from './toast-stack';
import { toasterClasses } from '../index';
export var Toast = function (_React$PureComponent) {
  _inherits(Toast, _React$PureComponent);
  var _super = _createSuper(Toast);
  function Toast() {
    var _this;
    _classCallCheck(this, Toast);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_timeoutIds", []);
    _defineProperty(_assertThisInitialized(_this), "startTimeout", function () {
      _this.clearTimeouts();
      if (isDefined(_this.props.timeout) && _this.props.timeout > 0) {
        _this.setTimeout(function () {
          return _this.triggerDismiss(true);
        }, _this.props.timeout);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "clearTimeouts", function () {
      if (_this._timeoutIds.length > 0) {
        var _iterator = _createForOfIteratorHelper(_this._timeoutIds),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var timeoutId = _step.value;
            window.clearTimeout(timeoutId);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this._timeoutIds = [];
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleDismiss", function () {
      safeInvoke(_this.props.onDismiss, false);
    });
    return _this;
  }
  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startTimeout();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.timeout !== this.props.timeout) {
        if (isDefined(this.props.timeout) && this.props.timeout > 0) {
          this.startTimeout();
        } else {
          this.clearTimeouts();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimeouts();
    }
  }, {
    key: "setTimeout",
    value: function setTimeout(callback, timeout) {
      var handle = window.setTimeout(callback, timeout);
      this._timeoutIds.push(handle);
      return function () {
        return window.clearTimeout(handle);
      };
    }
  }, {
    key: "triggerDismiss",
    value: function triggerDismiss(didTimeoutExpire) {
      this.clearTimeouts();
      safeInvoke(this.props.onDismiss, didTimeoutExpire);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, _excluded);
      var className = cn(toasterClasses.TOAST);
      return React.createElement("div", {
        className: className,
        onBlur: this.startTimeout,
        onFocus: this.clearTimeouts,
        onMouseEnter: this.clearTimeouts,
        onMouseLeave: this.startTimeout
      }, React.createElement(Message, {
        heading: props.heading,
        text: props.text,
        intent: props.intent,
        appearance: props.appearance,
        elevate: 2,
        isInline: true,
        onDismiss: this.handleDismiss
      }));
    }
  }]);
  return Toast;
}(React.PureComponent);
_defineProperty(Toast, "displayName", 'Toast');
_defineProperty(Toast, "defaultProps", {
  appearance: ControlAppearanceType.OUTLINE,
  position: ToasterPosition.TOP_RIGHT,
  timeout: 5000
});